angular.module("accordionAggiornamentoDocumenti.components", [])
    .component("accordionAggiornamentoDocumenti", {
        templateUrl: "ng/components/accordionAggiornamentoDocumenti/accordionAggiornamentoDocumenti.view.html",
        bindings: {

        },
        controllerAs: 'accordionAggiornamentoDocumentiCtrl',
        controller: function AggiornamentoDocumenti(
            es6Factory,
            $rootScope,
            $modalService,
            $searchUserService,
            $configService,
            $timeout,
            Pf,
            RiUserF,
            $userService,
            $portalService,
            $RichiestePostVenditaService,
            $transactionFactory,
            RichiestePostVendita,
            $location,
            $arcService

        ) {
            var self = this;

            self.es6Factory = es6Factory;

            self.$onInit = function () {
                self.$rootScope = $rootScope;
                var model = $transactionFactory.get();

                if (model) {
                    if (model.isModalUpgradeDoc) {
                        self.isModalUpgradeDoc = model.isModalUpgradeDoc
                        model.viewIndex = model.index;
                        model.id = model.idRichiesta;
                        var temp = {
                            metadata: {
                                aggiornamentoDocumenti: {
                                    persons: model.persons
                                }
                            }
                        }
                        Object.assign(model, temp)
                        self.richiestePostVendita = RichiestePostVendita.build(model);
                    } else {

                        self.richiestePostVendita = model;
                    }
                    $transactionFactory.clear();
                } else {
                    self.richiestePostVendita = RichiestePostVendita.build();
                }

                if (self.richiestePostVendita.viewIndex == 0) {
                    self.richiestePostVendita.viewIndex = 1100;
                }

                self.enableNext = false;
                self.listOfDisabledUser = [];
                self.inPurgatory = [];
                self.supportModel = {
                    warrantyList: [],
                    elementToAdd: [],
                    enableConfButton: false,
                    numberOfWarranties: 0,
                    totalWarrantiesAmount: 0,
                    enableModal: false,
                    index: 0,
                    loaderRemove: [],
                    nextStep: false,
                    showMapInfo: false,
                    mapInfo: ""
                }
                self.$portalService = $portalService
                self.isDealer = false;
                self.filterTools = {
                    orderType: "",
                    orderColumnName: ""
                }

                self.dealerUser = {
                    identifier: null
                };
                dealerUser();
                self.today = moment(new Date()).format('DD/MM/YYYY');
                self.riUserF = RiUserF.build();
                self.riUserF.listaPf = self.richiestePostVendita.metadata.aggiornamentoDocumenti.persons;
                self.enableModal = false;
                self.enableModalCensus = false;
                self.warnings = {
                    errorMsg: {
                        cf: ''
                    }
                }
                self.user = {}
                self.mapComuni = $rootScope.comuniMap;
                self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;
                self.riViewObj = {};

                self.loading = {};
                self.dropdown = {
                    entiRilascio: [],
                    listaProvince: []
                };

                self.model = {};

                self.validityPage();


                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                    self.popolateCheckListDownload();
                    self.popolateCheckListUpload();
                }

                retrieveStepInfo();
            }

            var getPfList = function () {
                // logica aggiunta per il nuovo tipo di informazione per aggiornamento documenti
                // informazione proveniente dalla modale.
                if (self.isModalUpgradeDoc) {
                    return
                }
                self.loading.loadingPfList = true;
                self.identifier = $configService.getUser().identifier;
                var ndg = $configService.getUser().ndg;
                $searchUserService
                    .getLinkedPersonPv(self.identifier, ndg)
                    .then(function (pfList) {

                        console.log('pf list: ', pfList);
                        if (self.isDigital) {
                            pfList && pfList.forEach(function (e) {
                                if (e.metadata.riUserF) {
                                    Object.assign(e.metadata.riUserF, {
                                        'validCertificate': e.validCertificate
                                    });
                                }
                            });

                        }

                        //take only the riUserF from each retrieved object
                        self.riUserF.listaPf = pfList && pfList
                            .map(function (pf) {
                                if (pf.metadata.riUserF) {
                                    pf.metadata.riUserF.datiIncompleti = pf.datiIncompleti;
                                    return pf.metadata.riUserF
                                } else {
                                    return
                                }

                            });
                        var riUserF = RiUserF.build(self.riUserF);
                        var listaPf = riUserF.listaPf;
                        var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                        listaPf = listaPf.map(function (pf) {
                            return Pf.build(pf).setDefaultPfValues(self.nationsList, comuni);
                        })
                        riUserF.listaPf = listaPf;

                        self.riUserF = riUserF;

                        if (!self.riUserF.listaPf[0]) {
                            self.riUserF.listaPf = []
                        }

                        self.validityPage();

                    })
                    .catch(function (err) {
                        console.log(err);
                        $rootScope.$broadcast('addAlert', {
                            text: 'ERROR_TEC'
                        });
                        self.riUserF = RiUserF.build();
                    })
                    .finally(function () {
                        self.loading.loadingPfList = false;
                    })
            }

            self.cleanUserFound = function () {
                self.tempPerson = {};
                self.PFresultsShown = false;
                self.searchObj.pfcf = "";
            }

            self.isForeignCf = function (cf) {
                return cf && cf.substr(11, 1) == 'Z';
            }

            self.editPf = function (pf) {
                pf = Pf.build(pf);
                pf.sesso = pf.sesso.toLowerCase();
                self.user = pf;
                pf.cf = pf.cf.toUpperCase();
                self.currentPf = JSON.parse(JSON.stringify(pf));


                $timeout(function () {
                    $modalService.openModal('censusPerson');
                    $("#footerInstant").css("z-index", "-1");
                    $('.financial-leasing__footer').css("z-index", "-1");
                }, 100)
                self.enableModal = true;
            }

            self.canSavePfData = function (pf) {
                if (pf.cf && pf.nome && pf.cognome && pf.sesso && pf.datiNascita.data) {

                    var cfInfo = {
                        cf: {
                            value: pf.cf
                        },
                        nome: pf.nome,
                        cognome: pf.cognome,
                        sesso: {
                            value: pf.sesso.toUpperCase()
                        },
                        Giorno: {
                            value: pf.datiNascita.data.split('/')[0]
                        },
                        Mese: {
                            value: pf.datiNascita.data.split('/')[1]
                        },
                        Anno: {
                            value: pf.datiNascita.data.split('/')[2]
                        },
                        provincia: pf.datiNascita.provincia,
                        comune: pf.datiNascita.comune
                    };

                    var infoFirmatario = true;
                    var infoTitolare = true;
                    var isFirmatario = false;
                    var isTitolare = false;
                    var infoAnagrafiche = !!(pf.nome &&
                        pf.cognome &&
                        pf.sesso &&
                        pf.datiNascita.data &&
                        pf.datiNascita.provincia &&
                        pf.datiNascita.comune &&
                        pf.residenza.indirizzo &&
                        pf.residenza.numeroCivico &&
                        pf.residenza.provincia &&
                        pf.residenza.comune &&
                        pf.residenza.cap
                    );

                    var infoDocumento = !!(pf.documento.tipo &&
                        pf.documento.numero &&
                        pf.documento.enteRilascio &&
                        pf.documento.luogo &&
                        (pf.documento.tipo == propMap['DOC_TYPE_PAS'] || pf.documento.tipo == propMap['DOC_TYPE_CAE'] || !!pf.documento.provincia) &&
                        pf.documento.dataRilascio &&
                        pf.documento.dataScadenza
                    );

                    if (pf.titolare.selected) {
                        isTitolare = true;
                        if (pf.titolare.pep === 'y') {
                            infoTitolare = !!(pf.titolare.pep && pf.titolare.motivazione);
                        } else {
                            infoTitolare = !!(pf.titolare.pep);
                        }
                    }
                    if (pf.firmatario.selected) {
                        isFirmatario = true;
                        infoFirmatario = !!pf.firmatario.ruolo && pf.telefono && pf.email;

                        var digitalSign = self.raccoltaInfo.userPickedDigitalSignature;
                        if (digitalSign) {
                            infoFirmatario = infoFirmatario && self.warnings.digitalSignDocuments['imgDocFirmatario1'];
                        }

                    }
                    if (!cfChecker.validateCfFromInfo(cfInfo, self.dropdown.stati)) {
                        $('input[name="codiceFiscale"]').addClass('has-error');
                        self.warnings.errorMsg.cf = 'Il codice fiscale o i dati inseriti sono errati.';
                        return false;
                    } else {
                        $('input[name="codiceFiscale"]').removeClass('has-error');
                        self.warnings.errorMsg.cf = '';
                        if (isTitolare && !isFirmatario) {
                            if (infoAnagrafiche && infoDocumento && infoTitolare) {
                                return true;
                            }
                        }

                        return (isTitolare || isFirmatario) && infoAnagrafiche && infoDocumento && infoFirmatario && infoTitolare;
                    }
                } else return false;
            }

            var dealerUser = function () {

                if ($portalService.isAru()) {

                    $userService.getDealerUser()
                        .then(function (dealer) {
                            if (dealer) {
                                self.dealerUser = dealer;

                            }
                        });
                }

            }

            self.validityPage = function (value) {
                self.enableNext = false;
                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PDI1') {

                    self.richiestePostVendita.metadata.aggiornamentoDocumenti.persons = self.riUserF.listaPf
                    self.enableNext = self.riUserF.listaPf && self.riUserF.listaPf.every(function (person) {
                        return person.isOk == true
                    });
                } else {
                    self.enableNext = value
                }
            }

            self.nextValidity = function () {
                return self.enableNext;
            }

            self.backValidity = function () {
                return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PDI1') || self.richiestePostVendita.readOnly ? true : false;
            }

            self.closeModal = function (value) {
                $modalService.closeModal(value);
            }

            self.sospendi = function () {
                $RichiestePostVenditaService
                    .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function () {
                        $location.path('/');
                        $modalService.closeModal("suspendInstance");
                    })
            }

            self.next = function () {
                self.supportModel.nextStep = true;
                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PDI1') {
                    cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
                    $RichiestePostVenditaService
                        .generateDocumentsPv(self.richiestePostVendita)
                        .then(function (response) {
                            if (response.success) {
                                $RichiestePostVenditaService
                                    .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                    .then(function (response) {
                                        self.richiestePostVendita = response;

                                        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                            retrieveStepInfo();
                                            self.popolateCheckListDownload();
                                            self.popolateCheckListUpload();
                                        }
                                        self.supportModel.nextStep = false;
                                    }).catch(function (error) {
                                        console.log(error);
                                        self.supportModel.nextStep = false;
                                    });
                            } else {
                                self.supportModel.nextStep = false;
                            }

                        }).catch(function (error) {
                            console.log(error);
                            self.supportModel.nextStep = false;
                        });
                } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                    cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
                    $RichiestePostVenditaService
                        .updateDocIdentita(self.richiestePostVendita.metadata.aggiornamentoDocumenti, self.richiestePostVendita.id,
                            self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                        .then(function () {
                            $location.path('/');
                            self.supportModel.nextStep = false;
                        }).catch(function (error) {
                            console.log(error);
                            self.supportModel.nextStep = false;
                        });
                }
            }

            self.goBackModal = function () {
                $modalService.closeModal('censusPerson');
                self.enableModal = false;
                self.validityPage()
            }

            self.updateOrderTable = function (data, order) {

                if (self.riUserF.listaPf.length < 2) {
                    return;
                }

                self.filterTools.orderColumnName = data;
                if (order == 'DESC') {
                    self.filterTools.orderType = 'DESC';
                    self.riUserF.listaPf = self.riUserF.listaPf
                        .sort(function (a, b) {
                            if (a[data] > b[data]) {
                                return -1
                            } else {
                                return 1
                            }
                        })
                } else {
                    self.filterTools.orderType = 'ASC';
                    self.riUserF.listaPf = self.riUserF.listaPf
                        .sort(function (a, b) {
                            if (a[data] < b[data]) {
                                return -1
                            } else {
                                return 1
                            }
                        })

                }


            }

            self.getWizardMap = function (viewIndex) {
                if (
                    $rootScope.wizardMap.find(function (element) {
                        return element.index == viewIndex;
                    })
                ) {
                    return $rootScope.wizardMap.find(function (element) {
                        return element.index == viewIndex;
                    }).viewName;
                }
            };

            self.changed = function (pf) {
                self.enableLoader = true;
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });

                var index = self.riUserF.listaPf.findIndex(function (el) {
                    return el.cf === pf.cf
                });
                //self.riUserF.listaPf.push(pf);
                self.riUserF.listaPf.splice(index, 1, pf);
                self.model.riUserF = self.riUserF;

                if (!pf.isOk) {
                    self.enableLoader = false;
                    $modalService.closeModal('censusPerson');
                    self.validityPage();
                    return;
                }
                $RichiestePostVenditaService.updatePersonalActivityPv(self.richiestePostVendita.id, Pf.build(pf))
                    .then(function (response) {
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });
                        if (response.success) {
                            self.enableModal = false;
                            $modalService.closeModal("censusPerson");
                            $("#footerInstant").css("z-index", "2");
                            $('.financial-leasing__footer').css("z-index", "2");
                            jQuery('.mCSB_scrollTools').css("z-index", "2");
                            pf.isOk = true;
                            pf.datiIncompleti = false;
                        } else {
                            pf.isOk = false;
                        }

                        self.validityPage();
                    })
                    .catch(function (error) {
                        self.enableLoader = false;
                        self.validityPage();
                    })
            }

            self.popolateCheckListDownload = function () {
                self.restDownloadRunning = true;
                $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                    .then(function (response) {
                        self.listOfDocumentDownload = response.listDocuments;
                        self.visibleDownloadChecklist = response.visible;
                        self.restDownloadRunning = false;
                    })
                    .catch(function (error) {
                        console.error(error);
                        self.restDownloadRunning = false;
                    })
            }

            self.popolateCheckListUpload = function () {
                self.restUploadRunning = true;

                $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                    .then(function (response) {
                        self.listOfDocumentUpload = response.listDocuments;
                        self.visibleUploadChecklist = response.visible;
                        self.message = response.message;
                        self.restUploadRunning = false;
                    })
                    .catch(function (error) {
                        console.error(error);
                        self.restUploadRunning = false;
                    })
            }

            self.back = function () {
                if (self.richiestePostVendita.readOnly) {
                    $location.path('/')
                } else {
                    self.supportModel.backStep = true;
                    $RichiestePostVenditaService
                        .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                        .then(function (response) {
                            self.supportModel.backStep = false;
                            self.richiestePostVendita = response;
                            retrieveStepInfo();
                        }).catch(function (error) {
                            console.log(error);
                            self.supportModel.backStep = false;
                        })
                }
            }

            var retrieveStepInfo = function () {
                self.clearLabelInfo = true;
                $RichiestePostVenditaService
                    .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                    .then(function (response) {
                        if (response.success) {
                            self.supportModel.showMapInfo = response.showBeMessage;
                            self.supportModel.mapInfo = response.message;
                            self.enabledLoader = false;
                        }
                        self.clearLabelInfo = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                        self.clearLabelInfo = false;
                    });
            }

            self.removePf = function (fromModal, index) {
                if (!fromModal) {
                    self.iesimoPf = index;
                    $modalService.openModal('confirmDeletedPf');
                    $("#footerInstant").css("z-index", "-1");
                    $('.financial-leasing__footer').css("z-index", "-1");

                } else {
                    $rootScope.$broadcast("pageLoader", {
                        action: "OPEN"
                    });
                    $arcService.deletePersonDocIdentita(self.riUserF.listaPf[self.iesimoPf], self.richiestePostVendita.id)
                        .then(function (response) {
                            if (response.success) {
                                self.riUserF.listaPf = self.riUserF.listaPf.filter(function (element) {
                                    return element.cf != self.riUserF.listaPf[self.iesimoPf].cf;
                                })
                                self.richiestePostVendita.metadata.aggiornamentoDocumenti.persons = self.riUserF.listaPf;
                                if (response.goToHome) {
                                    $location.path('/')
                                }
                            }
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });
                            self.validityPage();
                        })
                        .catch(function (error) {
                            $rootScope.$broadcast("pageLoader", {
                                action: "CLOSE"
                            });
                            self.validityPage();
                        })
                    $modalService.closeModal('confirmDeletedPf');
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                }
            }
        }
    });